import {Component, ContentChildren, forwardRef, Injector, Input, QueryList} from '@angular/core';
import {AbstractInput} from '../abstract-input';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {AutocompleteInputOptionComponent} from './autocomplete-input-options/autocomplete-input-option/autocomplete-input-option.component';
import {StartsWithPipe} from '../../../../pipes/starts-with/starts-with.pipe';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutocompleteInputComponent)
        }
    ],
    selector: 'vui-autocomplete-input',
    styleUrls: ['./autocomplete-input.component.scss'],
    templateUrl: './autocomplete-input.component.html'
})
export class AutocompleteInputComponent extends AbstractInput {
    @ContentChildren(AutocompleteInputOptionComponent, {descendants: true}) public autocompleteInputOptions: QueryList<AutocompleteInputOptionComponent>;
    @Input() public max: number;

    constructor(protected injector: Injector) {
        super(injector);

        this.autocompleteInputOptions = new QueryList<AutocompleteInputOptionComponent>();
    }

    public blur(): void {
        setTimeout(() => {
            this.focussed = false;
        }, 1);
    }

    public focus(): void {
        setTimeout(() => {
            this.focussed = true;
        }, 1);
    }

    /**
     * Check if there are any available options that aren't already
     * matched or filtered out to determine if the options should
     * be displayed
     */
    public searchable(): boolean {
        if (this.focussed) {
            if (new StartsWithPipe().transform(this.autocompleteInputOptions.toArray(), this.value, 'label').length > 0) {
                if (this.autocompleteInputOptions.toArray().filter((autocompleteInputOption) => JSON.stringify(autocompleteInputOption.value) === JSON.stringify(this.value)).length > 0) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }
    }

    /**
     * Select the chosen value
     * @param autocompleteInputOption
     */
    public select(autocompleteInputOption: AutocompleteInputOptionComponent): void {
        this.value = autocompleteInputOption.value;
        this.input.nativeElement.focus();
    }
}
